import { signoutRedirect } from '../services/api/user/userApi'; // OIDC (Google/Microsoft)
import { logoutFromMyLogin, clearAuthData as clearMyLoginAuth } from './myLoginAuth';
import paths from '../routes/paths';

export function unifiedLogout(redirectTo = paths.pupilDashLogin) {
  // Guard the argument. Wiring this straight to onClick hands us the click event, and assigning
  // that to window.location.href navigates to a nonsense URL — which is what produced the 404 on
  // logout rather than anything being wrong with the route itself.
  const target = typeof redirectTo === 'string' && redirectTo ? redirectTo : paths.pupilDashLogin;

  // Read the provider before clearing storage. The reads below used to happen after the keys had
  // already been removed, so provider detection always saw an empty store.
  let provider = null;
  try {
    provider = JSON.parse(localStorage.getItem('pupil'))?.provider || null;
  } catch (e) {
    provider = null;
  }
  const hadMyLoginToken = Boolean(localStorage.getItem('mylogin_access_token'));
  const hadOidcSession = Boolean(
    localStorage.getItem('oidc.user:https://api.identity.welbee.co.uk:CustomApp') ||
    localStorage.getItem('oidc.user:https://api.identity.welbee.co.uk:CustomAppLocal') ||
    localStorage.getItem('oidc.user:https://api.identity.welbee.co.uk:CustomAppStaging')
  );

  // Remove all local/session storage keys for all providers
  try {
    // OIDC/Google/Microsoft
    localStorage.removeItem('oidc.user:https://api.identity.welbee.co.uk:CustomApp');
    localStorage.removeItem('oidc.user:https://api.identity.welbee.co.uk:CustomAppLocal');
    localStorage.removeItem('oidc.user:https://api.identity.welbee.co.uk:CustomAppStaging');
    sessionStorage.clear();
    // MyLogin
    clearMyLoginAuth();
    // Email/Emoji/QR
    localStorage.removeItem('pupil');
    // General
    localStorage.removeItem('RedirectUrl');
    localStorage.removeItem('auth_redirect_url');
  } catch (e) {
    // Ignore errors
  }

  // Only send a pupil to MyLogin's OAuth logout if they actually signed in through MyLogin.
  // This condition used to read
  //   (pupil?.provider) || localStorage.getItem('mylogin_access_token') ? 'mylogin' : null
  // where || binds tighter than ?:, so *any* stored provider — emoji, QR, email — collapsed to
  // 'mylogin' and sent the pupil to an OAuth logout URL that means nothing for their session.
  if (provider === 'mylogin' || hadMyLoginToken) {
    logoutFromMyLogin(target);
    return;
  }

  // For OIDC (Google/Microsoft), call signoutRedirect (will redirect)
  if (hadOidcSession) {
    signoutRedirect();
    return;
  }

  // For all others (email, emoji, qr), just redirect
  window.location.href = target;
}

export default unifiedLogout;
